import { groupAuditListDef } from '../../../../backend/features/groups/shared/platform-functions/groupAuditListDef';
import { requireAnySystemPermission } from '../../../../backend/features/permissions/shared';
import { AuthError } from '@juvare/platform-app/App';
import { implementTypedPlatformFunction } from '@juvare/platform-sdk-react/backend/features/typed-platform-functions';
export const groupAuditList = implementTypedPlatformFunction(groupAuditListDef, (context, request) => {
    const hasGroupViewHistorySystemPermission = requireAnySystemPermission(context.userState, 'view-group-history');
    if (!hasGroupViewHistorySystemPermission) {
        throw new AuthError('Unauthorized');
    }
    return context.audit.list(request);
});
